import Model from "./Model";

export default class User extends Model {
  static type = "users";

  static adminRoles: Array<{ name: string; id: string }> = [
    { name: "Superadmin", id: "superadmin" },
    { name: "Admin", id: "admin" },
    { name: "Admin locale", id: "local_admin" },
  ];

  static doctorRoles: Array<{ name: string; id: string }> = [
    { name: "Utente", id: "doctor" },
  ];

  static roles: Array<{ name: string; id: string }> = [
    ...User.adminRoles,
    ...User.doctorRoles,
    { name: "Inattivo", id: "inactive" },
  ];

  email!: string;
  firstName!: string;
  lastName!: string;
  role!: string;
  active!: boolean;
  confirmedAt?: Date;
  request: Request;
  supervisor!: boolean;

  fullname(): string {
    return `${this.firstName} ${this.lastName.replace(
      "Basedia",
      "EasySurvey"
    )}`;
  }

  static getRoleLabel(role: string): string | undefined {
    return this.roles.find((o) => o.id === role)?.name;
  }

  isOneOf(roles: string[]) {
    return roles.includes(this.role);
  }

  get isAdmin() {
    return this.role === "admin";
  }

  get isSuperAdmin() {
    return this.role === "superadmin";
  }

  get isLocalAdmin() {
    return this.role === "local_admin";
  }

  get isDoctor() {
    return this.role === "doctor";
  }

  // Capability getters — used throughout the UI with v-if to hide, not disable,
  // actions a user cannot perform.
  get isStaff() {
    return this.isOneOf(["admin", "superadmin", "local_admin"]);
  }

  get canCRUDDatabase() {
    return this.isOneOf(["admin", "superadmin"]);
  }

  get canEditStructure() {
    return this.isOneOf(["admin", "superadmin"]);
  }

  get canManageAccess() {
    return this.isOneOf(["admin", "superadmin", "local_admin"]);
  }

  get canCreateUser() {
    return this.isOneOf(["admin", "superadmin", "local_admin"]);
  }

  get canPickAnyRole() {
    return this.isOneOf(["admin", "superadmin"]);
  }

  get canGenerateQR() {
    return this.isOneOf(["admin", "superadmin", "local_admin"]);
  }

  get canToggleQrSignup() {
    return this.isOneOf(["admin", "superadmin", "local_admin"]);
  }

  // Ability: the local admin can accept and reject access requests but
  // not delete them (no :destroy on SubscriptionRequest).
  get canDeleteRequests() {
    return this.isOneOf(["admin", "superadmin"]);
  }
}
